export default __webpack_public_path__ + "static/13_15-a2bdbd3e6da34414cec1f6ac5017ad31.png";